import { TQCInspectSpecDto } from 'src/dtos/tqcInspectSpec/tqcInspectSpecDto';

/** TQC5010 화면 그리드·API에서 사용하는 검사항목 DTO */
export interface TQC5010_R01Dto extends TQCInspectSpecDto {}

/** 신규 행 삽입·그리드 초기화 시 사용하는 기본값 */
export const defaultTQC5010_R01Dto: TQC5010_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspItemGroup: '',
	inspItemGroupNm: '',
	inspType: '',
	inspTypeNm: '',
	inspItemCd: '',
	inspItemNm: '',
	specValue1: '',
	specRange: '',
	specRangeNm: '',
	specValue2: '',
	inspUnit: '',
	valueType: '',
	valueTypeNm: '',
	inspMethod: '',
	inspMethodNm: '',
	remark: '',

	inserted: false,
	isModified: false,
};
